// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1634":"b7915baa","3243":"ea7c8c3d","5632":"5c153c23","7098":"d87de60e","9588":"70981737"}[chunkId] + ".chunk.css";
};